"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import OpenGraphPreview from "./OpenGraphPreview";
import GoogleWorkspaceCard from "./GoogleWorkspaceCard";
import { fetchLinkPreview, type GoogleWorkspaceLinkPreview } from "@/services/api/link-preview-api";
interface GoogleWorkspacePreviewProps {
  readonly href: string;
}
type PreviewState = {
  readonly type: "loading";
} | {
  readonly type: "success";
  readonly data: GoogleWorkspaceLinkPreview;
} | {
  readonly type: "error";
  readonly error: Error;
};
const isGoogleWorkspacePreview = (response: Awaited<ReturnType<typeof fetchLinkPreview>>): response is GoogleWorkspaceLinkPreview => {
  if (!response || typeof response !== "object") {
    return false;
  }
  const type = (response as {
    readonly type?: unknown;
  }).type;
  return typeof type === "string" && type.startsWith("google.");
};
export default function GoogleWorkspacePreview(t0) {
  const $ = _c(9);
  const {
    href
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: "loading"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [state, setState] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== href) {
    t2 = () => {
      let active = true;
      setState({
        type: "loading"
      });
      fetchLinkPreview(href).then(response => {
        if (!active) {
          return;
        }
        if (isGoogleWorkspacePreview(response)) {
          setState({
            type: "success",
            data: response
          });
          return;
        }
        setState({
          type: "error",
          error: new Error("Google workspace preview data unavailable")
        });
      }).catch(error => {
        if (active) {
          setState({
            type: "error",
            error: error instanceof Error ? error : new Error("Failed to load Google workspace preview")
          });
        }
      });
      return () => {
        active = false;
      };
    };
    t3 = [href];
    $[1] = href;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  if (state.type === "error") {
    throw state.error;
  }
  if (state.type === "success") {
    let t4;
    if ($[4] !== href || $[5] !== state.data) {
      t4 = <GoogleWorkspaceCard href={href} data={state.data} />;
      $[4] = href;
      $[5] = state.data;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] !== href) {
    t4 = <OpenGraphPreview href={href} preview={undefined} />;
    $[7] = href;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}